// src/index.js
import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';

// Prevent the browser from performing automatic scroll restoration.
// Do it as early as possible (before React mounts / routing).
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  try {
    window.history.scrollRestoration = 'manual';
  } catch (e) {
    // some browsers or privacy modes might throw; ignore
    // console.warn('Could not set scrollRestoration:', e);
  }
}

const container = document.getElementById('root');

// If react-snap has already pre-rendered HTML into #root,
// we hydrate it. Otherwise (dev mode, no pre-render) we do a normal render.
if (container && container.hasChildNodes()) {
  hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
